import React from "react";
import { inp, lbl } from "../shared";
import { SEASONS, ENVIRONMENTS, WEAR_TITLES, toggleSeason } from "../../../lib/classifications";

export const WearFields = ({ p, set }) => (
  <div className="md:col-span-2 border border-[#262421] p-4 mt-1 grid md:grid-cols-2 gap-6">
    <div>
      <label className={lbl}>{WEAR_TITLES.seasons.en} · {WEAR_TITLES.seasons.ar} (multi-select)</label>
      <div className="flex flex-wrap gap-x-5 gap-y-2.5 mt-2">
        {SEASONS.map((s) => (
          <label key={s.key} className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={(p.seasons || []).includes(s.key)} onChange={() => set("seasons", toggleSeason(p.seasons, s.key))}
              data-testid={`pf-season-${s.key}`} className="accent-[#C49A6C]" />
            {s.en} · {s.ar}
          </label>
        ))}
      </div>
    </div>
    <div>
      <label className={lbl}>{WEAR_TITLES.environment.en} · {WEAR_TITLES.environment.ar}</label>
      <select value={p.environment || ""} onChange={(e) => set("environment", e.target.value)} data-testid="pf-environment" className={inp}>
        <option value="">— Not set · غير محدد —</option>
        {ENVIRONMENTS.map((o) => <option key={o.key} value={o.key}>{o.en} · {o.ar}</option>)}
      </select>
    </div>
  </div>
);
